/**
 * Enums defined for use inside JSON fields on the API side.
 */

// See: api/src/lib/audiostream
export enum AudiostreamProfile {
  AAC = 'aac',
  HLS_AAC = 'hls-aac',
  HLS_MP3 = 'hls-mp3',
  MP3 = 'mp3',
}
